export enum UploadStatus {
	FAILURE = 'FAILURE',
	IN_PROCESS = 'IN_PROCESS',
	SUCCESS = 'SUCCESS',
}

export enum UploadStatusFilter {
	ALL = 'all',
	FAILURE = 'FAILURE',
	IN_PROCESS = 'IN_PROCESS',
	SUCCESS = 'SUCCESS',
}

export enum DownloadActionFileResult {
	DEFAULT = 'DEFAULT',
	ERROR = 'ERROR',
	SUCCESS = 'SUCCESS',
}

export enum OperationType {
	CREATION = 'CREATION',
	DEFAULT = 'DEFAULT',
	EXCLUSION = 'EXCLUSION',
	OTHER = 'OTHER',
	UPDATE = 'UPDATE',
}
